import FormController from 'controllers/form-controller';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class SignupSurveyFormController extends FormController {
  static targets = [
    'purposeOpt',
    'purposeHiddenField',
    'otherField',
    'formSubmitBtn',
    'signupFromResourceShowHiddenField',
    'dlLimitHiddenField',
  ];

  connect() {
    super.connect();

    this.flagLoaded();
  }

  disconnect() {
    super.disconnect();
  }

  validateFields = (event) => {
    event.preventDefault();

    super.showSpinner();

    // start: split test download_limit_modal
    if (this.downloadLimitModal || this.guestDownloadLimitModal) {
      this.dlLimitHiddenFieldTarget.value = true;
      this.signupFromResourceShowHiddenFieldTarget.value = true;
    }
    // end: split test download_limit_modal

    super.validateFields();

    if (this.formValid) {
      const selectedPurposeText = document.querySelector('.signup-survey__form__opt.is-selected').textContent.trim();
      triggerCustomEvent(events.sessions.user_signup_survey, {
        purpose: selectedPurposeText,
      });

      this.submit();
    }
  }

  selectPurpose = (event) => {
    const selectedPurposeKey = event.currentTarget.getAttribute('data-purpose-key');
    const selectedPurposeText = event.currentTarget.innerHTML;

    this.deselectCurrentOpt();

    event.currentTarget.classList.add('is-selected');

    if (selectedPurposeKey === 'other') {
      this.disableSubmitBtn();
      this.enableOtherField();
    } else {
      this.disableOtherField();
      this.setHiddenFieldValue(selectedPurposeText);
      this.enableSubmitBtn();
    }
  }

  enableSubmitBtn() {
    this.formSubmitBtnTarget.classList.remove('is-disabled');
  }

  disableSubmitBtn() {
    this.formSubmitBtnTarget.classList.add('is-disabled');
  }

  validateOtherField = (event) => {
    if (event.currentTarget.value) {
      this.enableSubmitBtn();
    } else {
      this.disableSubmitBtn();
    }
  }

  deselectCurrentOpt() {
    const currentSelectedOpt = document.querySelector('[data-target="signup-survey-form.purposeOpt"].is-selected');

    if (currentSelectedOpt) currentSelectedOpt.classList.remove('is-selected');
  }

  setHiddenFieldValue(purpose) {
    this.purposeHiddenFieldTarget.value = purpose.trim();
  }

  enableOtherField() {
    this.otherFieldTarget.disabled = false;
    this.otherFieldTarget.focus();
    this.purposeHiddenFieldTarget.disabled = true;
  }

  disableOtherField() {
    this.purposeHiddenFieldTarget.disabled = false;
    this.otherFieldTarget.disabled = true;
  }

  get editorIndexPage() {
    return document.querySelector('body').classList.contains('editor-index');
  }

  get downloadLimitModal() {
    const modalWrapElem = this.element.closest('.ez-session-modal__wrap');
    return modalWrapElem.classList.contains('from-dl-limit-modal');
  }

  // start: split test download_limit_modal
  get guestDownloadLimitModal() {
    const modalWrapElem = this.element.closest('.ez-session-modal__wrap');
    return modalWrapElem.classList.contains('download-limit-form');
  }
  // end: split test download_limit_modal
}
